import React, { useEffect } from 'react';
import WeekOfSupplyCard from './WeekOfSupplyCard';
import PropTypes from 'prop-types';
import {
	getWeekOfSupplyStoreData,
	getWeekOfSupplyDCData,
} from '../../../../redux/actions/itemDrillDownActions';
import { UserPortalContext } from '../../../../context/appcontext';
import { useDispatch, useSelector } from 'react-redux';
import {
	DATA_NOT_LOADING_MSG,
	DATA_NOT_AVAILABLE,
} from '../../../../constants/constant';

function WeekOfSupplyWrapper(props) {
	const {
		wosType,
		selectedTab,
		weekFilter,
		startDate,
		endDate,
		itemNum,
		itemName,
	} = props;
	const dispatch = useDispatch();

	const portalUserContext = React.useContext(UserPortalContext);
	const selectedFilters = useSelector(
		(state) => state.salesReducer.selectedFilters
	);
	const selectedView = useSelector(
		(state) => state.appGuideReducer.selectedView
	);

	const { category } = selectedFilters;

	const {
		weekOfSupplyStore,
		weekOfSupplyStoreLoading,
		weekOfSupplyStoreError,
	} = useSelector((state) => state.itemDrillDownReducer);

	const { weekOfSupplyDC, weekOfSupplyDCLoading, weekOfSupplyDCError } =
		useSelector((state) => state.itemDrillDownReducer);

	const errorMsgWosDC =
		weekOfSupplyDCError === 204 ? DATA_NOT_AVAILABLE : DATA_NOT_LOADING_MSG;

	const errorMsgWosStore =
		weekOfSupplyStoreError === 204 ? DATA_NOT_AVAILABLE : DATA_NOT_LOADING_MSG;

	useEffect(() => {
		const params = {
			period: weekFilter,
			portalUserContext,
			itemNum,
			startDate,
			endDate,
		};
		if (wosType === 'Store') {
			dispatch(getWeekOfSupplyStoreData(params));
		} else {
			dispatch(getWeekOfSupplyDCData(params));
		}
	}, [weekFilter, startDate, endDate, selectedView]);

	return (
		<WeekOfSupplyCard
			data={wosType === 'DC' ? weekOfSupplyDC : weekOfSupplyStore}
			isLoading={
				wosType === 'DC' ? weekOfSupplyDCLoading : weekOfSupplyStoreLoading
			}
			errorMsg={wosType === 'DC' ? errorMsgWosDC : errorMsgWosStore}
			showToggle={false}
			title={`Weeks of supply - ${wosType}`}
			weekFilter={weekFilter}
			category={category}
			type={wosType}
			itemNum={itemNum}
			itemName={itemName}
			selectedTab={selectedTab}
		/>
	);
}

WeekOfSupplyWrapper.propTypes = {
	weekFilter: PropTypes.number,
	category: PropTypes.string,
	wosType: PropTypes.string,
	selectedTab: PropTypes.string,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	itemNum: PropTypes.string,
	itemName: PropTypes.string,
};

export default WeekOfSupplyWrapper;
